import styled from 'styled-components';
import theme from '../../../styles/theme';
import { getColors } from 'vmfcom-lib/utils';

export default styled.section`
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }

  .modal-header-form {
    z-index: 51;
    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      max-width: 680px;
    }
    width: 100%;
    height: auto;
    position: fixed;
    background-color: ${theme.colors.white};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%); /* Center the modal */
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
    border-radius: 8px;

    &__heading {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .close-button {
        cursor: pointer;
      }
    }

    &__header {
      color: ${props => props.theme.colors.claytonBlue};
    }

    &__list {
      padding: 0 2rem;

      li {
        line-height: 20px;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 20px;

      li,
      ul {
        padding: 0;
        margin: 0;
      }
    }

    &__form-body {
      display: flex;
      flex-direction: column;
      gap: 10px;

      input {
        box-sizing: border-box;
        border: 1px solid ${theme.colors.grey4};
        padding: 1rem 0.8rem;
        width: 100%;
        font-weight: 400;
        color: ${theme.colors.black};
        font-family: ${theme.fonts.primary};
        font-size: 1.25rem;
        line-height: ${theme.lineHeights.paragraph.xs};

        &::placeholder {
          color: ${theme.colors.grey1};
        }
      }
    }

    &__form-intro {
      color: ${props => props.theme.colors.black};
      line-height: 20px;
    }

    &__disclaimer {
      p {
        color: ${props => props.theme.colors.grey1};
        line-height: 14px;
        font-size: 12px;
      }
    }

    &__submit-button {
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        background-color: ${props =>
          getColors(props.buttonAndTextColors).primary};
        color: ${props => getColors(props.buttonAndTextColors).secondary};
      }

      button:not(:disabled):hover {
        background-color: ${props =>
          getColors(props.buttonAndTextColors).secondary};
        color: ${props => getColors(props.buttonAndTextColors).primary};
      }
    }

    svg path {
      fill: ${props => props.theme.colors.claytonBlue};
    }
  }
`;
